const icons = {
  apple: '\\e000',
  book_reader: '\\e003',
  brand_bullhorn: '\\e02a',
  brand_crown: '\\e02d',
  brand_file_check: '\\e02b',
  brand_graduation_cap: '\\e02c',
  building: '\\e006',
  buildings: '\\e005',
  bullhorn: '\\e01b',
  certificate: '\\e008',
  chart_pie: '\\e020',
  bolt_circle: '\\e023',
  dollar_circle: '\\e009',
  undo_circle: '\\e027',
  cog: '\\e012',
  comments: '\\e024',
  contrast: '\\e025',
  crown: '\\e00a',
  desktop: '\\e01d',
  envelope: '\\e014',
  file_add: '\\E041',
  file_acrobat: '\\E040',
  file_check_alt: '\\e018',
  file_check: '\\e019',
  file_dollar: '\\e00d',
  file_edit: '\\e01a',
  file_upload: '\\e017',
  file: '\\e00c',
  files: '\\e016',
  folder_check: '\\e013',
  gem: '\\e00b',
  graduation_cap: '\\e007',
  home_check: '\\e010',
  home: '\\e011',
  map_marker: '\\e00f',
  newspaper: '\\e026',
  padlock: '\\e01e',
  pencil: '\\e01f',
  rocket: '\\e022',
  search_dollar: '\\e01c',
  search: '\\e00e',
  signal: '\\e001',
  suitcase: '\\e004',
  training: '\\e021',
  user_add: '\\e028',
  users_add: '\\e002',
  users: '\\e029',
  archive: '\\E02E',
  plus_minus: '\\E02F',
  ticked: '\\E030',
  times: '\\E031',
  arrow_left: '\\E032',
  paper_plane: '\\E033',
  align_center: '\\E035',
  align_justify: '\\E036',
  align_start: '\\E037',
  align_end: '\\E038',
  back: '\\E039',
  bold: '\\E03A',
  calendar: '\\E03B',
  clock: '\\E03C',
  clock_back: '\\E03D',
  delete_circle: '\\E03E',
  delete_thin: '\\E03F',
  link: '\\E042',
  list_unordered: '\\E043',
  list_ordered: '\\E044',
  search_thin: '\\E045',
  menu: '\\E046',
  add_circle: '\\E047',
  question_mark: '\\E048',
  cut: '\\E049',
  scissors: '\\E049',
  slash: '\\E04A',
  star_alt: '\\E04B',
  star: '\\E04C',
  text_zoom: '\\E04D',
  underline: '\\E04E',
  user_double: '\\E04F',
  user_remove: '\\E050',
  user_verify: '\\E051',
  bath: '\\E052',
  bed: '\\E053',
  clock_add: '\\E055',
  car: '\\E054',
  shield_add: '\\E034',
  grid: '\\E056',
  arrow_circle: '\\E05d',
  console: '\\E05e',
  photo: '\\E05f',
  property_file: '\\E060',
  property_me: '\\E061',
  property_tree: '\\E062',
  mri_property_tree: '\\E06f',
  palace: '\\E063',
  mri_palace: '\\E06e',
  fan: '\\E057',
  giraffe: '\\E058',
  gust: '\\E059',
  heating: '\\E05a',
  cloud_rain: '\\E05b',
  smoke_alarm: '\\E05c',
  monitor: '\\E01d',
  allclear: '\\E064',
  beer: '\\E065',
  attachment: '\\E066',
  dots_outline: '\\E067',
  dots_solid: '\\E068',
  download: '\\E069',
  eye_off: '\\E06a',
  eye_on: '\\E06b',
  pizza: '\\E06c',
  sats: '\\E06d',
  play: '\\E070',
  bulb: '\\E071',
  console_alt: '\\E073',
  id_card: '\\E05e',
  notes: '\\E074',
  id_check: '\\E072',
  info: '\\E075',
  trash: '\\E076',
  arrow_right: '\\E077',
  calendar_clock: '\\E078',
  alarm_clock: '\\E079',
  logout: '\\E07a',
  integration: '\\E07b',
};

export default icons;
